import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";

export function Testimonials() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/testimonials/public").then(({ data }) => setItems(data.testimonials || [])).catch(() => setItems([]));
  }, []);

  if (items === null) return null; // avoid layout flash while loading

  return (
    <section className="mx-auto max-w-6xl px-6 py-16" data-testid="landing-testimonials">
      <h2 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">From our first builders</h2>
      {items.length === 0 ? (
        <div className="mt-4 rounded-2xl border border-dashed border-brand-line bg-brand-surface/40 p-6" data-testid="testimonials-placeholder">
          <p className="text-slate-700">
            We're in early beta, working closely with our first founders. Real stories will show up here as
            they launch and make their first sales. <span className="font-semibold">Be one of the first.</span>
          </p>
        </div>
      ) : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <figure key={i} className="flex flex-col rounded-2xl border border-brand-line bg-white p-6 shadow-soft" data-testid={`testimonial-${i}`}>
              <Quote size={20} className="text-brand" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-slate-700">"{t.quote}"</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                {t.photo ? (
                  <img src={t.photo} alt={t.name} className="h-10 w-10 rounded-full object-cover" />
                ) : (
                  <span className="grid h-10 w-10 place-items-center rounded-full bg-brand-surface text-sm font-semibold text-brand">
                    {(t.name || "?").charAt(0).toUpperCase()}
                  </span>
                )}
                <div>
                  <p className="text-sm font-semibold text-brand-deep">{t.name}</p>
                  {t.business_name && <p className="text-xs text-slate-400">{t.business_name}</p>}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      )}
    </section>
  );
}
